module.exports = __webpack_public_path__ + "img/logo-mini.33ce20dc.png";